// extracted by mini-css-extract-plugin
export default {"wrapper":"SankeyChart_wrapper__C55QM","tooltipWrapper":"SankeyChart_tooltipWrapper__ENdC2","tooltip":"SankeyChart_tooltip__Le7SQ","text":"SankeyChart_text__GYhqW"};